import { render, staticRenderFns } from "./q5.vue?vue&type=template&id=408d4194&scoped=true"
import script from "./q5.vue?vue&type=script&lang=js"
export * from "./q5.vue?vue&type=script&lang=js"
import style0 from "./q5.vue?vue&type=style&index=0&id=408d4194&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d4194",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('408d4194')) {
      api.createRecord('408d4194', component.options)
    } else {
      api.reload('408d4194', component.options)
    }
    module.hot.accept("./q5.vue?vue&type=template&id=408d4194&scoped=true", function () {
      api.rerender('408d4194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/questionTemplates/q5.vue"
export default component.exports